import React, {useState, useEffect} from 'react';
import { MapContainer, TileLayer, Marker, Popup, GeoJSON} from 'react-leaflet'
import WardBoundaries from '../../data/basemaps/BBMP_Wards_2011_region_GEO.json'
import WardData from '../../data/BBMP_Wards_Summary_data.json'
import * as turf from '@turf/turf'

function BangaloreWardsParksArea() {
  const [selectedWard, setSelectedWard] = useState(null);
  const [selectedColor, setSelectedColor] = useState("#000000");
  const [wardParkAreaRatios, setWardParkAreaRatios] = useState(null);

  useEffect(() => {
    // WardBoundaries.features.map(ward => {
    //   console.log(ward.properties.WARD_NO + ' - ' + ward.properties.WARD_NAME);
    //   return;
    // })
    //console.log(WardBoundaries);
    let wardParkAreaRatios = [];
    WardData.forEach((ward) => {
      wardParkAreaRatios[ward.wardno] = ward.parkAreaRatio;
    });
    setWardParkAreaRatios(wardParkAreaRatios);
    // console.log(wardParkAreaRatios);
    // console.log(wardParkAreaRatios[1]);
  }, []);


  // https://colorbrewer2.org/#type=sequential&scheme=BuGn&n=9
  let colorArray = ['#00441b', '#006d2c', '#238b45', '#41ae76', '#66c2a4', '#99d8c9', '#ccece6', '#e5f5f9', '#f7fcfd']
  let getColor = (d) => {
    return  d > 50000 ? colorArray[0] :
            d > 40000 ? colorArray[1] :
            d > 30000  ? colorArray[2] :
            d > 20000  ? colorArray[3] :
            d > 10000   ? colorArray[4] :
            d > 5000   ? colorArray[5] :
            d > 1000   ? colorArray[6] :
            d > 100   ? colorArray[6] :
                      '#ffffff';
  }

  let wardStyle = (feature) => {
    console.log(feature);
    console.log(wardParkAreaRatios);
    console.log(feature.properties.WARD_NO);
    console.log(wardParkAreaRatios[parseInt(feature.properties.WARD_NO)])
    return {
        // feature.properties.density
        fillColor: getColor(wardParkAreaRatios[parseInt(feature.properties.WARD_NO)]),
        weight: 2,
        opacity: 1,
        fillOpacity: 0.9,
        color: 'black',
        weights: 1,
    };
  }

  let onWardClick = (e) => {
    console.log(e.target);
    return;
    e.target.setStyle({
      fillColor : selectedColor,
    });
    console.log("onWardClick - Set color from state is : " + selectedColor);
  }

  let getLatLongFromClick = (e) => {
    alert("Lat, Lon : " + e.latlng.lat + ", " + e.latlng.lng)
  }
  
  let onLeafletClick = (e) => {
    onWardClick(e);
    // getLatLongFromClick(e);
  }

  let onWardMouseOver = (e) => {
    return;
    e.target.setStyle({
      fillColor : '#0000FF',
    });
  }

  let changeColor = (e) => {
    console.log("Color from state is : " + selectedColor);
    console.log("Changing the color to : " + e.target.value);
    setSelectedColor(e.target.value); 
  }


  let onEachWard = (ward,layer) => {
    // console.log(JSON.stringify(w.properties));
    // console.log(l);
    // console.log(ward);
    layer.setStyle(wardStyle(ward));
    const areaOfWard = turf.area(ward).toFixed(2);
    // console.log(ward.properties.WARD_NO + ' - ' + ward.properties.WARD_NAME + '-' + areaOfWard);
    layer.bindPopup(ward.properties.WARD_NO + ' - ' + ward.properties.WARD_NAME);
    layer.on({
      click : onLeafletClick,
      mouseover : onWardMouseOver,
    });
  }


  // Reference - https://leafletjs.com/examples/choropleth/
  return (
    <>
    <MapContainer center={[12.9784, 77.5813]} zoomSnap={0.25} zoom={11.5} scrollWheelZoom={true}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" opacity='0.2'
      />
      {/* <GeoJSON style = {wardStyle()} data={WardBoundaries.features} onEachFeature={(f,l) => onEachWard(f,l)}/> */}
      {/* Uncomment <GeoJSON data={WardBoundaries.features} onEachFeature={(f,l) => onEachWard(f,l)}/> */}
      <GeoJSON data={WardBoundaries.features}/>
      {/* <Marker position={[12.9052, 77.5629]}>
        <Popup>
          A pretty CSS3 popup. <br /> Easily customizable.
        </Popup>
      </Marker> */}
    </MapContainer>
    {/* <input type = "color" value = {selectedColor} onChange = {changeColor} /> */}
    </>
  );
}

export default BangaloreWardsParksArea;